<div class="catalog-tab" *transloco="let t">
  <div class="filters">
    <input class="search-input" [formControl]="search" [placeholder]="t('cardsAdminCatalogSearch')" />
    <select [formControl]="rarity">
      <option value="">{{ t('cardsAdminCatalogRarityAll') }}</option>
      @for (r of rarities; track r) {
        <option [value]="r">{{ t(rarityLabelKeys[r] || r) }}</option>
      }
    </select>
  </div>

  @if (rows().length) {
    <table class="catalog-table">
      <tr>
        <th></th>
        <th>{{ t('cardsAdminRewardCard') }}</th>
        <th>{{ t('cardsAdminCatalogReleased') }}</th>
        <th>{{ t('cardsAdminCatalogHidden') }}</th>
        <th>{{ t('cardsAdminCatalogNoRandomDrop') }}</th>
        <th>{{ t('cardsAdminCatalogLocalOnly') }}</th>
      </tr>
      @for (card of rows(); track card.id) {
        <tr>
          <td><img class="thumb" [src]="card.thumbUrl" alt="card" /></td>
          <td>
            {{ card.name.en }}
            <span class="meta">{{ t(rarityLabelKeys[card.rarity] || card.rarity) }} · {{ card.value }}</span>
          </td>
          <td>{{ card.releasedAt | date: 'shortDate' }}</td>
          <td>
            <input type="checkbox" [checked]="card.hidden" (change)="toggleHidden(card, $any($event.target).checked)" />
            @if (card.rewardCount) {
              <span class="warn">{{ t('cardsAdminCatalogInUseReward') }}</span>
            }
            @if (card.mapDropCount) {
              <span class="warn">{{ t('cardsAdminCatalogInUseMap', { count: card.mapDropCount }) }}</span>
            }
          </td>
          <td>
            <!-- hidden implies undroppable, so the toggle is disabled and shown
                 off while hidden; the stored value is untouched, so un-hiding
                 restores the card's own setting. -->
            <input
              type="checkbox"
              [checked]="card.hidden ? false : card.noRandomDrop"
              [disabled]="card.hidden"
              (change)="toggleNoRandomDrop(card, $any($event.target).checked)"
            />
          </td>
          <td>
            <input
              type="checkbox"
              [checked]="card.localOnly"
              (change)="toggleLocalOnly(card, $any($event.target).checked)"
            />
          </td>
        </tr>
      }
    </table>

    <div class="pager">
      <button [disabled]="offset() === 0" (click)="goTo(offset() - pageSize)">
        {{ t('cardsAdminCatalogPrev') }}
      </button>
      <span class="meta">{{ offset() + 1 }}–{{ offset() + rows().length }} / {{ total() }}</span>
      <button [disabled]="offset() + pageSize >= total()" (click)="goTo(offset() + pageSize)">
        {{ t('cardsAdminCatalogNext') }}
      </button>
    </div>
  } @else {
    <div class="empty">{{ t('cardsAdminCatalogEmpty') }}</div>
  }
</div>
